import { scopeSchema } from '@guiker/access-control-shared'
import { yup } from '@guiker/yup-util'

import { RentPaymentRoleNames } from '../../../permissions'

export const accessControlClaimsSchema = yup.object({
  scope: scopeSchema,
  userId: yup.string(),
  emailAddress: yup.string().required(),
  acl: yup
    .object({
      payment: yup
        .object({
          roles: yup
            .array()
            .of(yup.string().oneOf(Object.values(RentPaymentRoleNames)))
            .required(),
          references: yup.array().of(yup.string()).optional(),
        })
        .required(),
    })
    .required(),
})

export type AccessControlClaimsSchema = yup.InferType<typeof accessControlClaimsSchema>
